package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

val Svg.Pan_vertical: ImageVector
    get() {
        if (_pan_vertical != null) {
            return _pan_vertical!!
        }
        _pan_vertical = Builder(
            name = "Pan_vertical", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f
        ).apply {
            group {
                path(
                    fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero
                ) {
                    moveTo(16.0f, 7.0f)
                    lineTo(12.0f, 2.5f)
                    lineTo(8.0f, 7.0f)
                    lineTo(16.0f, 7.0f)
                    close()
                    moveTo(16.0f, 17.0f)
                    lineTo(8.0f, 17.0f)
                    lineTo(12.0f, 21.5f)
                    lineTo(16.0f, 17.0f)
                    close()
                    moveTo(14.0f, 12.0f)
                    curveTo(14.0f, 10.895f, 13.105f, 10.0f, 12.0f, 10.0f)
                    curveTo(10.895f, 10.0f, 10.0f, 10.895f, 10.0f, 12.0f)
                    curveTo(10.0f, 13.105f, 10.895f, 14.0f, 12.0f, 14.0f)
                    curveTo(13.105f, 14.0f, 14.0f, 13.105f, 14.0f, 12.0f)
                    close()
                }
            }
        }
            .build()
        return _pan_vertical!!
    }

private var _pan_vertical: ImageVector? = null
